import { Component } from '@angular/core'

@Component({
	selector: 'loader',
	template: ` <span></span> `,
	styleUrl: './loader.component.scss',
})
export class LoaderComponent {}
